"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const export_service_1 = __importDefault(require("./export.service"));
let VehicleExportService = class VehicleExportService extends export_service_1.default {
    constructor() {
        super(...arguments);
        this.headers = [{
                header: 'ID',
                traversal: '_id',
            }, {
                header: 'VIN',
                traversal: 'vin',
            }, {
                header: 'Marke',
                traversal: 'modelData.make',
            }, {
                header: 'Modell',
                traversal: 'modelData.model',
            }, {
                header: 'Bodycode',
                traversal: 'bodycode',
            }, {
                header: 'Bestellnummer',
                traversal: 'vehicleData.order.orderNumber',
            }, {
                header: 'Erstzulassung',
                traversal: 'vehicleData.registration.firstRegistration',
                specialType: 'Date',
            }, {
                header: 'Datum Abmeldung',
                traversal: 'vehicleData.registration.deregistrationDate',
                specialType: 'Date',
            }, {
                header: 'Aktuell zugelassen',
                traversal: 'vehicleData.registration.registered',
                specialType: 'Boolean',
            }, {
                header: 'Standort',
                traversal: 'vehicleData.inventory.location',
            }, {
                header: 'Fahrzeugtyp',
                traversal: 'vehicleData.availability.state',
            }, {
                header: 'Verfügbarkeit',
                traversal: 'vehicleData.availability.code',
            }, {
                header: 'Lagereingang',
                traversal: 'vehicleData.inventory.deliveryDate',
                specialType: 'Date',
            }, {
                header: 'Produktionsstatus',
                traversal: 'vehicleData.production.productionState',
            }, {
                header: 'UPE Hersteller',
                traversal: 'vehicleData.price.retailPrices.manufacturer',
            }, {
                header: 'UPE Eingangsrechnung',
                traversal: 'vehicleData.price.retailPrices.invoice',
            }, {
                header: 'Aktuelle UPE',
                traversal: 'vehicleData.price.retailPrices.offer',
            }, {
                header: 'Verkaufspreis',
                traversal: 'vehicleData.price.campaignPrice',
            }, {
                header: 'Online Preis',
                traversal: 'vehicleData.price.onlinePrice',
            }, {
                header: 'Datum Kaufvertrag',
                traversal: 'vehicleData.availability.sellData.contractDate',
                specialType: 'Date',
            }, {
                header: 'Verkäufer bei Verkauf',
                traversal: 'vehicleData.availability.sellData.seller',
                specialType: 'UserId',
            }, {
                header: 'Verkäufer bei Reservierung',
                traversal: 'vehicleData.availability.reservationData.seller',
                specialType: 'UserId',
            }, {
                header: 'Enddatum Reservierung',
                traversal: 'vehicleData.availability.reservationData.reservationDate',
                specialType: 'Date',
            }, {
                header: 'Kunde bei Verkauf',
                traversal: 'vehicleData.availability.sellData.customer',
            }, {
                header: 'Kunde bei Reservierung',
                traversal: 'vehicleData.availability.reservationData.customer',
            }, {
                header: 'Datum Eingangsrechnung',
                traversal: 'vehicleData.costs.invoiceDate',
                specialType: 'Date',
            }, {
                header: 'Kennzeichen',
                traversal: 'vehicleData.registration.licence',
            }, {
                header: 'Kilometerstand',
                traversal: 'vehicleData.mileage.total',
            }, {
                header: 'Datencheck',
                traversal: 'dataCheck',
                specialType: 'Exists',
            }, {
                header: 'Serienoptionen',
                traversal: 'vehicleData.features.seriesOptions',
                specialType: 'Object_Array',
                objectKey: 'code',
            }, {
                header: 'Aufpreisoptionen',
                traversal: 'vehicleData.features.additionalOptions',
                specialType: 'Object_Array',
                objectKey: 'code',
            }, {
                header: 'Außenfarbe (Herstellercode)',
                traversal: 'vehicleData.features.exteriorColor.manufacturerCode',
            }, {
                header: 'Außenfarbe (Herstellername)',
                traversal: 'vehicleData.features.exteriorColor.manufacturerName',
            }, {
                header: 'Innenfarbe (Herstellercode)',
                traversal: 'vehicleData.features.interiorColor.manufacturerCode',
            }, {
                header: 'Innenfarbe (Herstellername)',
                traversal: 'vehicleData.features.interiorColor.manufacturerName',
            }];
    }
};
VehicleExportService = __decorate([
    (0, core_1.Injectable)()
], VehicleExportService);
exports.default = VehicleExportService;
